module.exports = __webpack_public_path__ + "static/media/degreeandcert.52d272ea.svg";